import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import {
  CRMDevelopersBoost,
  CRMDevelopersTechDriven,
  CRMDevelopersRichFeatured,
  CRMDevelopersHighSoftware,
  CRMDevelopersOptimalSecurity,
  CRMDevelopersEnhancedIntegerations,
  CRMDevelopersBoaderScale,
  CRMDevelopersUser,
  CRMDevelopersData,
} from "../../../../app-constants";

function Websecurityefficient() {
  return (
    <section className="websecurity_efficient p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Benefits of Our <span>Custom CRM Software Development</span>{" "}
              Services
            </h2>
            <p>
              As a leading custom CRM development company, we empower businesses
              to enhance their client management systems and maximize their
              benefits.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              // autoplay={false}
              spaceBetween={20}
              modules={[Autoplay]}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 2,
                },
                1366: {
                  slidesPerView: 3,
                },
                1600: {
                  slidesPerView: 3,
                },
              }}
              className="web_case_slider"
            >
              <SwiperSlide>
                <div className="web-security-box">
                  <div className="web-security-icon">{CRMDevelopersBoost}</div>
                  <div className="web-security_content">
                    <h5>Competitive Edge</h5>
                    <p style={{ color: "#fff" }}>
                      Gain a competitive advantage with custom CRM solutions
                      tailored to your business. Align technology with your
                      unique needs, giving you a distinctive edge that sets you
                      apart from your competitors.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web-security-box">
                  <div className="web-security-icon">
                    {CRMDevelopersTechDriven}
                  </div>
                  <div className="web-security_content">
                    <h5>Tech-driven Business Solutions</h5>
                    <p style={{ color: "#fff" }}>
                      Achieve seamless integration between your business
                      processes and technology with a custom CRM system. Our
                      solutions enhance efficiency, reduce friction, and promote
                      a smoother workflow tailored to your specific
                      requirements.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web-security-box">
                  <div className="web-security-icon">
                    {CRMDevelopersRichFeatured}
                  </div>
                  <div className="web-security_content">
                    <h5>Rich-featured Tech Stack</h5>
                    <p style={{ color: "#fff" }}>
                      Custom CRM software offers a rich set of features beyond
                      the generic approach. Enjoy industry-specific
                      functionalities designed to meet your unique needs,
                      ensuring that every tool and capability drives your
                      business forward.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web-security-box">
                  <div className="web-security-icon">
                    {CRMDevelopersHighSoftware}
                  </div>
                  <div className="web-security_content">
                    <h5>High-Performing Software</h5>
                    <p style={{ color: "#fff" }}>
                      Experience reliable and stable operations with a custom
                      CRM solution. Our focus on robust performance ensures
                      minimal downtime and smooth functioning, even as demands
                      increase.
                    </p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="web-security-box">
                  <div className="web-security-icon">
                    {CRMDevelopersOptimalSecurity}
                  </div>
                  <div className="web-security_content">
                    <h5>Optimal Security Parameters</h5>
                    <p style={{ color: "#fff" }}>
                      Our custom CRM solutions prioritize security,
                      incorporating advanced features, encryption, and proactive
                      measures to protect your sensitive data and ensure its
                      confidentiality and integrity.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web-security-box">
                  <div className="web-security-icon">
                    {CRMDevelopersEnhancedIntegerations}
                  </div>
                  <div className="web-security_content">
                    <h5>Enhanced Integrations</h5>
                    <p style={{ color: "#fff" }}>
                      Integrate and consolidate your business ecosystem
                      seamlessly with broad integration capabilities. Custom CRM
                      development allows for the integration of diverse tools,
                      platforms, and applications, enhancing collaboration and
                      data sharing across your organization.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web-security-box">
                  <div className="web-security-icon">
                    {CRMDevelopersBoaderScale}
                  </div>
                  <div className="web-security_content">
                    <h5>Broader Scalability</h5>
                    <p style={{ color: "#fff" }}>
                      Adapt effortlessly to your evolving business needs with a
                      scalable custom CRM solution. Whether expanding your
                      customer base, adding new functionalities, or entering new
                      markets, our tailored CRM system provides the flexibility
                      to grow without constraints.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web-security-box">
                  <div className="web-security-icon">{CRMDevelopersUser}</div>
                  <div className="web-security_content">
                    <h5>Enhanced User Engagement</h5>
                    <p style={{ color: "#fff" }}>
                      Increase the usability and popularity of CRM with the help
                      of individual CRM templates cooperating with various work
                      processes. The applications are easy to use and are
                      designed with friendly interfaces and features that help
                      your team members embrace the tools during work reducing
                      learning time.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web-security-box">
                  <div className="web-security-icon">{CRMDevelopersData}</div>
                  <div className="web-security_content">
                    <h5>Making Decisions Based on Data</h5>
                    <p style={{ color: "#fff" }}>
                      Use the information provided through our in-house
                      developed CRM software to make wiser decisions. Convenient
                      tools for generating reports and analyzing customers’
                      activity, sales rates, and productive performance enable
                      decision-makers to focus on strategic actions supported by
                      the actual data gained.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Websecurityefficient;
